import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import * as Yup from 'yup';

import SubmitButton from 'components/Widgets/SubmitButton';

import { Formik, Form as FormikForm } from 'formik';

import HorizontalTextField from 'components/new_ui/Form/HorizontalTextField';

import { useContext as useUsersContext } from 'components/Users/Context';

import {
  CardElement,
  useStripe,
  useElements,
} from '@stripe/react-stripe-js';

import useIot from 'components/Common/Iot/Hooks/useIot';
import { PubSub } from 'aws-amplify';

export default function CheckoutForm({
  clientSecret, closeModal, setWaitPayment, currency,
}) {
  const { state: stateUsers } = useUsersContext();

  const stripe = useStripe();
  const elements = useElements();

  const [message, setMessage] = useState(null);

  const formSchema = Yup.object().shape({
    name: Yup.string().required('Card Holder Name is required'),
  });

  useIot();

  useEffect(() => {
    PubSub.subscribe(`user-${stateUsers.user.attributes.token}`).subscribe({
      next: ({ value }) => {
        if (value.type === 'students.payment') {
          window.location.assign('/members/wallet');
        }
        if (value.type === 'terminated_payment') {
          window.location.assign('/members/programs');
        }
      },
    });
  }, [stateUsers.user]);

  const onSubmitHundler = (values, { setSubmitting }) => {
    if (!stripe || !elements) {
      return;
    }

    setSubmitting(true);

    stripe.confirmCardPayment(
      clientSecret,
      {
        payment_method: {
          card: elements.getElement(CardElement),
          billing_details: {
            name: values.name,
          },
        },
      },
    ).then((response) => {
      if (response.error) {
        setMessage(response.error.message);
        setSubmitting(false);
      } else if (
        response.paymentIntent
        && response.paymentIntent.status === 'succeeded'
      ) {
        setMessage(null);
        closeModal();
        setWaitPayment(true);
      }
    });
  };

  return (
    <Formik
      validationSchema={formSchema}
      initialValues={{
        name: stateUsers.user.attributes.specific.full_name,
      }}
      onSubmit={onSubmitHundler}
    >
      {({ isSubmitting }) => (
        <FormikForm className="needs-validation" noValidate="">
          <p className="text-center">
            All prices are in
            {' '}
            {currency}
            {' '}
            and all sales are final
          </p>

          <div className="mt-3">
            <HorizontalTextField
              name="name"
              placeholder="Card Holder Name"
              required
            />
          </div>

          <div className="mt-3 card-field">
            <CardElement id="payment-element" />
          </div>

          <p className="text-danger text-center small">{message}</p>

          <div className="mt-3 d-grid">
            <SubmitButton
              loading={isSubmitting}
              disabled={isSubmitting || !stripe || !elements}
            >
              Pay Now
            </SubmitButton>

          </div>
        </FormikForm>
      )}
    </Formik>
  );
}

CheckoutForm.propTypes = {
  clientSecret: PropTypes.string.isRequired,
  closeModal: PropTypes.func.isRequired,
  setWaitPayment: PropTypes.func.isRequired,
  currency: PropTypes.string,
};

CheckoutForm.defaultProps = {
  currency: 'USD',
};
